import { render, staticRenderFns } from "./EventsDrawer.vue?vue&type=template&id=5dda6bfb&"
import script from "./EventsDrawer.vue?vue&type=script&lang=ts&"
export * from "./EventsDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports